import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { popup } from '../utils';
import {
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  GooglePlus as GooglePlusIcon,
  LinkedIn as LinkedInIcon,
  Email as EmailIcon,
} from './Icons/shareIcons';


class ShareButtons extends Component {
  constructor (props) {
    super(props);
    this.shareVia = this.shareVia.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleButtonClick (e) {
    const { onButtonClick } = this.props;
    const serviceName = e.currentTarget.id;
    this.shareVia(serviceName);
    onButtonClick(serviceName);
  }

  shareVia (service) {
    const { url, title, description, publisher } = this.props;
    switch (service) {
      case 'facebook': {
        const params = {
          u: url,
          display: 'popup',
          ref: 'plugin',
        };
        return popup(`https://www.facebook.com/sharer/sharer.php?${qs.stringify(params)}`, 'Share on Facebook');
      }
      case 'twitter': {
        const params = {
          url,
          text: publisher.twitter ? `Via @${publisher.twitter}` : '',
        };
        // if (publisher.twitter) {
        //   params.via = publisher.twitter;
        // }
        return popup(`https://twitter.com/intent/tweet?${qs.stringify(params)}`, 'Share on Twitter');
      }
      case 'linkedin': {
        const params = {
          url,
          title,
          summary: description,
          mini: 'true',
        };
        return popup(`https://www.linkedin.com/shareArticle?${qs.stringify(params)}`, 'Share on LinkedIn', { width: 990, height: 700 });
      }
      case 'googleplus':
        return popup(`https://plus.google.com/share?${qs.stringify({ url })}`, 'Share on Google+', { width: 400, height: 550 });
      case 'email': {
        const params = {
          subject: `${publisher.name}: ${title}`,
          body: `From ${publisher.name}:\n\n${description}\n\n${url}`,
        };
        window.location.href = `mailto:?${qs.stringify(params)}`;
        break;
      }
      default:
        return null;
    }
  }

  render () {
    const { hoverEffects, fill, iconSize, iconStyles, include } = this.props;
    const iconProps = {
      fill,
      className: !hoverEffects ? 'no-hover' : '',
      size: iconSize,
      style: iconStyles,
      onClick: this.handleButtonClick,
    };
    const iconComponents = {
      facebook: <FacebookIcon key="facebook" id="facebook" {...iconProps} />,
      twitter: <TwitterIcon key="twitter" id="twitter" {...iconProps} />,
      linkedin: <LinkedInIcon key="linkedin" id="linkedin" {...iconProps} />,
      googleplus: <GooglePlusIcon key="googleplus" id="googleplus" {...iconProps} />,
      email: <EmailIcon key="email" id="email" {...iconProps} />,
    };
    return include.filter(str => str in iconComponents).map(service => iconComponents[service]);
  }
}

ShareButtons.propTypes = {
  include: PropTypes.arrayOf(PropTypes.string),
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  publisher: PropTypes.object,
  fill: PropTypes.string,
  iconSize: PropTypes.number,
  iconStyles: PropTypes.object,
  hoverEffects: PropTypes.bool,
  onButtonClick: PropTypes.func,
};

ShareButtons.defaultProps = {
  include: ['facebook', 'twitter', 'linkedin', 'email'],
  iconSize: 48,
  iconStyles: {
    float: 'left',
    margin: '0 5px',
  },
  hoverEffects: true,
  onButtonClick: () => {},
};

export default ShareButtons;



// WEBPACK FOOTER //
// ./src/components/ShareButtons.js